import * as yup from 'yup';

export const schema=()=>{
     return yup.object().shape({
        Title: yup.string().required('Title is required'),
        InstructorDisplayName: yup.string().required('InstructorDisplayName is required'),
       
       
      });
}